import { findIndex } from "lodash"

const templateState = {
    id: -1,
    type: null,
    held: false,
    open: false,
    concentration: 0,
    description: "",
    onShelf: true,
    inScene: true,
    // controlsVisible: false
}

export default (state = templateState, action) => {
  let currentMarker;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_MARKER" && !action.type.includes("@redux")) {
      if(action.payload.hasOwnProperty("id")){
          if(state.protocolSection.scene.apparatus.hasOwnProperty("marker")){
            currentMarker = state.protocolSection.scene.apparatus.marker[findIndex(state.protocolSection.scene.apparatus.marker, { id: action.payload.id })]
          }
      }
  }
  switch (action.type) {
    case 'CREATE_MARKER':

      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props }

      if(protocolSection.scene.apparatus.hasOwnProperty("marker")){
        protocolSection.scene.apparatus.marker = [ ...protocolSection.scene.apparatus.marker, newObj ]
      } else {
        protocolSection.scene.apparatus.marker = [newObj]
      }

      return { ...state, ...{
        protocolSection: protocolSection
      } }
      // --
    case 'SET_MARKER_OPEN':
      currentMarker.open = action.payload.open
      protocolSection.scene.apparatus.marker[findIndex(state.marker, { id: action.payload.id })] = currentMarker

      return { ...state, ...{
        protocolSection: protocolSection
      } }

    default:
      return state;
  }
};
